import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton } from '@mui/material';
import { useState } from 'react';
import Drawer from '../../components/Drawer';
import { AccountMenu } from '../../components/Header/AccountMenu';
import { useAuth } from '../../contexts/authContext';
import ProfilePage from '../ProfilePage/ProfilePage';

export interface ProfileDrawerProps {
  open: boolean;
  onClose: () => void;
}

export const ProfileDrawer = (props: ProfileDrawerProps) => {
  const { user } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const isMenuOpen = Boolean(anchorEl);

  return (
    <Drawer
      actionButton={
        user !== null && (
          <>
            <IconButton
              onClick={event => setAnchorEl(event.currentTarget)}
              size="large"
              aria-haspopup="true"
              aria-controls={isMenuOpen ? 'account-menu' : undefined}
              aria-expanded={isMenuOpen ? 'true' : undefined}
            >
              <MoreVertIcon />
            </IconButton>

            <AccountMenu
              anchorEl={anchorEl}
              open={isMenuOpen}
              onClose={() => setAnchorEl(null)}
            />
          </>
        )
      }
      sx={{ bgcolor: 'background.accent' }}
      {...props}
    >
      <Box sx={{ bgcolor: 'background.accent', height: 55 }} />
      <Box mt={-7}>
        <ProfilePage />
      </Box>
    </Drawer>
  );
};
